import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { firstValueFrom } from 'rxjs';
import { Categoria, CategoriaComAnexo } from 'src/app/consts/categoria';
import { MensagemResposta } from 'src/app/consts/mensagem';
import { AnexoReformaService } from 'src/app/services/anexo-reforma-service.service';
import { CategoriasService } from 'src/app/services/categorias.service';
import { ErrorPageComponent } from 'src/app/shared/custom-components/error-page/error-page.component';
import { SpinnerComponent } from 'src/app/shared/custom-components/spinner/spinner.component';

@Component({
  selector: 'app-adicionar-categoria',
  templateUrl: './adicionar-categoria.component.html',
  styleUrls: ['./adicionar-categoria.component.css']
})
export class AdicionarCategoriaComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  carregando: boolean = true;
  AnexoTitulo: string
  AnexoId: number
  TodasCategorias = new MatTableDataSource<Categoria>();
  displayedColumns: string[] = [
    'nome',
    'ncm',
    'cest',
    'naturezaReceita',
    'button'
  ];

  filtroControl = new FormControl('');

  constructor(@Inject(MAT_DIALOG_DATA) data,
    private anexoService: AnexoReformaService,
    private categoriaService: CategoriasService,
    private dialog: MatDialog) {
    this.AnexoId = data.AnexoId
    this.AnexoTitulo = data.AnexoTitulo
    console.log(data)
  }

  ngOnInit(): void {
    this.carregando = true;
    firstValueFrom(this.categoriaService.getTodos()).then(
      (response: Array<CategoriaComAnexo>) => {
        console.log(response)
        this.TodasCategorias.data = response.filter(c => {
          return c.AnexoId !== this.AnexoId
        })
      }
    ).finally(() => {
      this.carregando = false;

    })

    this.filtroControl.valueChanges.subscribe(valor => {
      this.TodasCategorias.filter = valor?.trim().toLowerCase() ?? '';
    });


    this.TodasCategorias.filterPredicate = (data: Categoria, filter: string) => {
      return (
        data.Nome?.toLowerCase().includes(filter) ||
        data.Ncm?.toLowerCase().includes(filter) ||
        data.Cest?.toLowerCase().includes(filter) ||
        data.NaturezaReceita?.toLowerCase().includes(filter)
      );
    };
  }

  ngAfterViewInit(): void {
    this.TodasCategorias.paginator = this.paginator;
  }

  async AdicionarAnexo(categoria: CategoriaComAnexo) {
    categoria.AnexoId = this.AnexoId
    console.log(categoria)
    this.post(categoria)
  }

  post(categoria) {
    const dialogRef = this.dialog.open(SpinnerComponent, { panelClass: 'spinner' })
    firstValueFrom(
      this.categoriaService.post([categoria])
    ).then((response: MensagemResposta[]) => {
      if (response[0].Codigo == 'CRM00001') {
        this.abrirPaginaErro('sistema', response);
        dialogRef.close();
        this.TodasCategorias.data = this.TodasCategorias.data
          .filter(c => c.Id !== categoria.Id);

        // Atualiza o dataSource da tabela
        this.TodasCategorias._updateChangeSubscription();
      }
    }).catch(err => {
      this.abrirPaginaErro('erro', err)
    });
  }

  abrirPaginaErro(tipo, mensagem) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      tipo: tipo,
      mensagem: mensagem,
    };

    this.dialog.open(ErrorPageComponent, dialogConfig);
  }
}
